import * as React from "react";
import { Backdrop, Box, CircularProgress, Modal } from "@mui/material";

interface LoadingModalProps {
  open: boolean;
}

const LoadingModal: React.FC<LoadingModalProps> = (props) => {
  const { open } = props;

  return (
    <Modal open={open}>
      <Box>
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="primary" />
        </Backdrop>
      </Box>
    </Modal>
  );
};

export default LoadingModal;
